var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#5577F1",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9998 19.0524C16.7903 19.0524 19.0524 16.7903 19.0524 13.9998C19.0524 13.0358 18.7824 12.1348 18.3139 11.3684L13.8074 16.0797L11.348 13.6203L12.2055 12.7628L13.7882 14.3455L17.554 10.4086C16.6411 9.50507 15.3856 8.94715 13.9998 8.94715C11.2093 8.94715 8.94715 11.2093 8.94715 13.9998C8.94715 16.7903 11.2093 19.0524 13.9998 19.0524Z",
    fill: "#375ACE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22C15.5822 22 17.129 21.5308 18.4446 20.6518C19.7602 19.7727 20.7855 18.5233 21.391 17.0615C21.9965 15.5997 22.155 13.9911 21.8463 12.4393C21.5376 10.8874 20.7757 9.46197 19.6569 8.34315C18.538 7.22433 17.1126 6.4624 15.5607 6.15372C14.0089 5.84504 12.4003 6.00346 10.9385 6.60896C9.47672 7.21446 8.22729 8.23984 7.34824 9.55544C6.46919 10.871 6 12.4177 6 14L7.18913 14C7.18913 12.6529 7.58858 11.3361 8.33697 10.2161C9.08536 9.09604 10.1491 8.22307 11.3936 7.70758C12.6381 7.19208 14.0076 7.0572 15.3287 7.32C16.6499 7.5828 17.8635 8.23147 18.816 9.18399C19.7685 10.1365 20.4172 11.3501 20.68 12.6713C20.9428 13.9924 20.8079 15.3619 20.2924 16.6064C19.7769 17.8509 18.904 18.9146 17.7839 19.663C16.6639 20.4114 15.3471 20.8109 14 20.8109L14 22Z",
    fill: "#375ACE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/availability.76c2ee065d65e1e3cf4de534e1b71b92.svg";
export { ForwardRef as ReactComponent };